const calcDV = (digits, table) => {
    var sum = digits.reduce(function (sum, cur, i) { return i < table.length ? sum + cur * table[i] : sum; }, 0);
    var rem = sum % 11;
    return rem < 2 ? 0 : 11 - rem;
}

export const validateCPF = (value) => {
    var cpf = value.replace(/\D/g, '');
    var dv = new Array(2);

    var c = cpf.split(/(?!$)/u).map(function (char) { return parseInt(char); });
    
    if (cpf.length !== 11) {
        return false;
    }
    // Validação dos CPFs inválidos conhecidos
    if (/^(.)\1+$/.test(cpf)) {
        return false;
    }
    // Validação do primeiro digito
    var table = [10, 9, 8, 7, 6, 5, 4, 3, 2];
    dv[0] = calcDV(c, table);
    // Validação segundo digito
    table.unshift(11);
    dv[1] = calcDV(c, table);
    return dv[0] === c[9] && dv[1] === c[10];
}


export const validateCNPJ = (value) => {
    var cnpj = value.replace(/\D/g, '');
    var dv = new Array(2);
    var c = cnpj.split(/(?!$)/u).map(function (char) { return parseInt(char); });
    if (cnpj.length !== 14) {
        return false;
    }
    // Validação dos CNPJs inválidos conhecidos
    if (/^(.)\1+$/.test(cnpj)) {
        return false;
    }
    // Validação do primeiro digito
    var table = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    dv[0] = calcDV(c, table);
    // Validação segundo digito
    table.unshift(6);
    dv[1] = calcDV(c, table);
    return dv[0] === c[12] && dv[1] === c[13];
}

export const validateDoc = (value) => {
    value = value.replace(/\D/g, '');
    return (value.length === 11 && validateCPF(value)) || value.length === 14 && validateCNPJ(value)
}

export const validateCreditCard = (value) => {
    // accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(value)) return false;

    // The Luhn Algorithm. It's so pretty.
    var nCheck = 0, nDigit = 0, bEven = false;
    value = value.replace(/\D/g, "");

    for (var n = value.length - 1; n >= 0; n--) {
        var cDigit = value.charAt(n);
        nDigit = parseInt(cDigit, 10);

        if (bEven) {
            if ((nDigit *= 2) > 9) nDigit -= 9;
        }

        nCheck += nDigit;
        bEven = !bEven;
    }

    return (nCheck % 10) == 0;
}

export const validateZipcodeBr = (value) => {
    value = value.replace(/\D/g, "");
    return value.length === 8
}

